import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { SingleSelect } from '@common/components/FormElements/SingleSelect';
import { useTranslation } from '@common/hooks/useTranslation';
import { Field } from '@components/FormElements';
import { options } from './options';

type Props = {
  value?: boolean;
  label?: string | React.ReactNode;
  onChange: (key: boolean) => void;
  error?: string;
  disabled?: boolean;
};

export const TargetLocationField = ({
  value,
  disabled,
  label,
  onChange,
  error
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 z-10 relative">
      <Field
        label={label || t('postJobForm.fieldLabel.targetLocation')}
        message={
          error && (
            <div className="mt-sm">
              <ErrorMessage>{error}</ErrorMessage>
            </div>
          )
        }
      >
        <div className="mt-sm">
          <SingleSelect<boolean>
            testID="job-form-targetLocation"
            disabled={disabled}
            onChange={onChange}
            options={options(t)}
            value={value}
          />
        </div>
      </Field>
    </div>
  );
};
